// Beat an army on demand — `GrowBoard`'s inverse, and beside it for that reason.
//
// Clearing a camp is the gate on everything a run does next: a region opens, an
// objective latches, a stage turns over, the board grows. Reaching it honestly
// means playing out a mate or waiting three turns on a despair stamp, so anyone
// looking at what comes *after* has to win a war first — and the run smoke, to
// avoid that, was reaching into `position.board` and patching four maps by hand.
//
// One button per living army, because a wave can arrive under a colour that was
// not on the board. The last one is refused by the reducer, not hidden here: a
// dev control that vanishes is a control you go looking for.

import type { DevDispatch } from "../DevMenu";
import { Btn } from "../kit";
import { useGame } from "../useGame";
import { useSessionView } from "../useSessionView";
import { Loose, Note, Fold } from "./parts";

export function BeatArmy({ dispatch }: { dispatch: DevDispatch }) {
  // Every living army, named — the readouts list them for a board nobody is
  // playing, which is the same list.
  const living = useSessionView().readouts.armies;
  const yours = useGame().board.facts().run?.side;

  return (
    <Fold id="defeat" title="Beat an army">
      <Loose>
        {living.map(({ side, name }) => (
          <Btn
            key={side}
            small
            variant={side === yours ? "default" : "danger"}
            data-testid={`dev-defeat-${side}`}
            disabled={living.length < 2}
            onClick={() => dispatch({ type: "dev-defeat", side })}
          >
            {name}
            {side === yours ? " (yours)" : ""}
          </Btn>
        ))}
      </Loose>
      <Note>
        Scrap where it stood, and a crown off its king — the same thing a stage boundary leaves,
        through the same command log.
      </Note>
    </Fold>
  );
}
